import { getNestedProperty } from "@/utils";
import { useTranslation } from "react-i18next";

export default function InputErrorMessage({ formik, name }) {
  const { t } = useTranslation();

  const fieldKeys = name.split(".");
  const touched = getNestedProperty(formik.touched, fieldKeys);
  const errors = getNestedProperty(formik.errors, fieldKeys);

  return (
    <div className={`${errors && touched ? 'visible' : 'invisible'}`} style={{
      height: 25
    }}>
      <span className="text-danger">{t(errors)}</span>
    </div>
  )
}
